export class WordBookGroupBookChapter {
    constructor(Word,BookGroup,Book,Chapter) {
      this.Word = Word;
      this.BookGroup=BookGroup
      this.Book=Book;
      this.Chapter=Chapter;
    }
  }
